import {
  Badge,
  Button,
  ButtonGroup,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useContext, useState } from "react";
import DescriptionIcon from "@mui/icons-material/Description";
import { defaultRightWindowWidget } from "../../pages/PageConfiguration";
import { DocLinkListContext } from "../../hooks/context/DocLinkListContext";

const AppBar = ({
  setMapSplit,
  mapSplit,
  tableSplit,
  setTableSplit,
  rightWindow,
  setRightWindow,
  portal,
  pageConfig,
}) => {
  const docLinkListCtx: any = useContext(DocLinkListContext);

  return (
    <div
      style={{ display: "flex", justifyContent: "space-between" }}
      className="appbar"
    >
      <ButtonGroup color="primary" variant="contained" size="small" sx={{marginLeft:"4px",padding:"6px",backgroundColor:"#4db970"}}>
        <Button
          size="small"
          variant="contained"
          color="primary"
          sx={rightWindow === "docViewer" ? { backgroundColor: "#0e6347","&:hover": {backgroundColor:"#14976b !important" } } : {
            "&:hover": {backgroundColor:"#14976b !important" } 
           }}
          title="doc/photo view"
          onClick={() => {
            if (rightWindow !== "docViewer") {
              setRightWindow("docViewer");
              return;
            }
            setRightWindow(defaultRightWindowWidget);
          }}
        >
          {docLinkListCtx.data.length ? (
            <Badge
              badgeContent={docLinkListCtx.data.length}
              color="secondary"
            />
          ) : (
            ""
          )}
          <DescriptionIcon sx={{color:"white"}} fontSize="medium" />
        </Button>
        {/* </div> */}
        {pageConfig.widgets.streetView && (
          <Button
            variant="contained"
            size="small"
            sx={
              rightWindow === "google-street-view"
                ? { backgroundColor: "#0e6347",
                "&:hover": {backgroundColor:"#14976b !important" }
                 }
                : {"&:hover": {backgroundColor:"#14976b !important" }}
            }
            title="street view"
            onClick={() => {
              if (rightWindow !== "google-street-view") {
                setRightWindow("google-street-view");
                return;
              }
              setRightWindow(defaultRightWindowWidget);
              return;
            }}
          >
            <img
              style={{ maxHeight: "27px" }}
              src={`${process.env.PUBLIC_URL}/google-street-view.png`}
              alt="Google Street View"
            />
          </Button>
        )}
      </ButtonGroup>
      {rightWindow.length?<div
        id="1"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: 10,
        }}
      >
        <div
          className={
            mapSplit === 1
              ? "appbar__toggle--left appbar__toggle--left--selected"
              : "appbar__toggle--left"
          }
          onClick={() => setMapSplit(1)}
        >
          <div
            className={
              mapSplit === 1
                ? "appbar_toggle--selected"
                : "appbar_toggle--not--selected"
            }
          >
            <span
              className={
                mapSplit === 1
                  ? "appbar__toggle__box--left appbar__toggle__box--left--selected"
                  : "appbar__toggle__box--left"
              }
            >
              <div className="appbar__toggle__box--left--fill"></div>
            </span>
          </div>
        </div>
        <div
          className={
            mapSplit === 2
              ? "appbar__toggle--middle appbar__toggle--middle--selected"
              : "appbar__toggle--middle"
          }
          onClick={() => setMapSplit(2)}
        >
          <div
            className={
              mapSplit === 2
                ? "appbar_toggle--selected"
                : "appbar_toggle--not--selected"
            }
          >
            <span
              className={
                mapSplit === 2
                  ? "appbar__toggle__box--middle--left appbar__toggle__box--middle--left--selected"
                  : "appbar__toggle__box--middle--left"
              }
            ></span>
            <span
              className={
                mapSplit === 2
                  ? "appbar__toggle__box--middle--right appbar__toggle__box--middle--right--selected"
                  : "appbar__toggle__box--middle--right"
              }
            ></span>
          </div>
        </div>
        <div
          className={
            mapSplit === 3
              ? "appbar__toggle--right appbar__toggle--right--selected"
              : "appbar__toggle--right"
          }
          onClick={() => setMapSplit(3)}
        >
          <div
            className={
              mapSplit === 3
                ? "appbar_toggle--selected"
                : "appbar_toggle--not--selected"
            }
          >
            <span
              className={
                mapSplit === 3
                  ? "appbar__toggle__box--right appbar__toggle__box--right--selected"
                  : "appbar__toggle__box--right"
              }
            >
              <div className="appbar__toggle__box--right--fill"></div>
            </span>
          </div>
        </div>
      </div>:""}
      {portal.user ? (
        <Typography variant="subtitle2">
          Welcome {portal.user.fullName} to the{" "}
          {pageConfig?.name ? pageConfig.name : ""} map!!
        </Typography>
      ) : (
        <Typography variant="subtitle2">
          Welcome Public User to the {pageConfig?.name ? pageConfig.name : ""}{" "}
          map!!
        </Typography>
      )}
    </div>
  );
};

export default AppBar;
